import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { resetPassword } from "aws-amplify/auth";

import Button from '@mui/material/Button';

import Validate from "../utility/FormValidation";
import { Box, Paper, Stack, Snackbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import logo from './../../logos/Logo_Cerchio_1000px.svg'
import bgImage from '../../background/bgd_login.jpg'

export default function ForgotPassword({ auth }) {

    const [credentialsForm, setCredentialsForm] = useState({
        email: '',
        checkEmail: false,
        isSending: false,
        openSnack: false,
        messageSnack: "",
        errors: {
            email: "",
            cognito: ""
        },
    });



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setCredentialsForm({
            ...credentialsForm,
            openSnack: false,
            messageSnack: ''
        });
    };

    const handleSubmit = async () => {
        try {
            setCredentialsForm({
                ...credentialsForm,
                isSending: true,
            });
            await resetPassword({ username: credentialsForm.email });
            setCredentialsForm({
                ...credentialsForm,
                email: '',
                isSending: false,
                checkEmail: true,
                openSnack: true,
                messageSnack: 'We have sent you an email with the link'
            });
        } catch (error) {
            setCredentialsForm({
                ...credentialsForm,
                errors: {
                    ...credentialsForm.errors,
                    cognito: error.message || 'Unexpect error during authentication',
                }
            });
        }
    }


    const onInputChange = event => {
        const error = Validate(credentialsForm => { return { ...credentialsForm, [event.target.id]: event.target.value } });
        setCredentialsForm(credentialsForm => {
            return {
                ...credentialsForm,
                [event.target.id]: event.target.value,
                errors: { ...credentialsForm.errors, ...error, cognito: null }
            }
        });

    }


    const history = useHistory();
    const redirect = (dst) => {
        history.push(dst);
    }

    const handleEnterKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit()
        }
    }

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                overflow: 'hidden',
                height: '100vh',
                width: '100%',
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            id='bg-container'
        >
            <Paper sx={{ width: '60%', minWidth: '23em', maxWidth: '40em', m: 'auto', marginTop: '8em', paddingTop: '2em' }} elevation={3}>
                <Stack
                    component="form"
                    noValidate
                    autoComplete="off"
                    direction='column'
                    alignItems='center'
                >
                    {/*  <FormErrors formerrors={credentialsForm.errors} /> */}

                    <img src={logo} height="100" alt="pagination logo" />



                    <Typography sx={{ m: '1em', marginTop: '2em', width: '80%', maxWidth: '30em' }}>
                        Please enter the email address associated with your account and we'll
                        email you a password reset link.
                    </Typography>
                    <TextField
                        label="email"
                        id="email"
                        value={credentialsForm.email}
                        onChange={onInputChange}
                        error={credentialsForm.errors.email !== ""}
                        helperText={credentialsForm.errors.email ? credentialsForm.errors.email : ''}
                        sx={{ m: 1, width: '80%', maxWidth: '30em' }}
                        onKeyDown={handleEnterKeyDown}
                    />


                    {credentialsForm.errors.cognito !== undefined &&

                        <Typography variant='caption' color='error' sx={{ marginBottom: '1em' }}>
                            {credentialsForm.errors.cognito}
                        </Typography>

                    }


                    <Button
                        color="primary"
                        disabled={credentialsForm.errors.email !== '' || credentialsForm.email === ''}
                        loading={credentialsForm.isSending}
                        //loadingPosition="start"
                        variant="contained"

                        onClick={handleSubmit}
                        sx={{ m: '1em', marginBottom: '2em' }}
                    >
                        Submit
                    </Button>


                </Stack >

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={credentialsForm.openSnack}
                    autoHideDuration={60000}
                    onClose={handleClose}
                    message={credentialsForm.messageSnack}
                    action={
                        <Stack direction='row'>
                            <Button color="primary" variant='contained' onClick={() => redirect('/login')}>
                                Return to Login
                            </Button>

                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Stack>
                    }

                />


            </Paper >
        </Box>


    )

}
